import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { useState } from 'react';
import { gqlGetNotificationRecipients } from '../graphql';
import {
  formatResponsePayload,
  notificationRecipientStatusLabel,
  notificationResponseValueLabel,
} from '../constants';
import { formatDateTime } from 'shared-pages/utils/helpers';

export const exportColumns = (t) => {
  return [
    { fieldName: 'cpName', fieldTitle: t('Σημείο συλλογής'), fieldType: 'TEXT' },
    { fieldName: 'addressLine1', fieldTitle: t('Διεύθυνση'), fieldType: 'TEXT' },
    { fieldName: 'addressLine2', fieldTitle: t('Διεύθυνση 2'), fieldType: 'TEXT' },
    { fieldName: 'addressArea', fieldTitle: t('Περιοχή'), fieldType: 'TEXT' },
    { fieldName: 'addressCity', fieldTitle: t('Πόλη'), fieldType: 'TEXT' },
    { fieldName: 'addressNomos', fieldTitle: t('Νομός'), fieldType: 'TEXT' },
    { fieldName: 'email', fieldTitle: t('Email'), fieldType: 'TEXT' },
    { fieldName: 'statusLabel', fieldTitle: t('Κατάσταση'), fieldType: 'TEXT' },
    { fieldName: 'responseLabel', fieldTitle: t('Απάντηση'), fieldType: 'TEXT' },
    { fieldName: 'respondedDateText', fieldTitle: t('Ημερομηνία απάντησης'), fieldType: 'TEXT' },
    { fieldName: 'responsePayloadText', fieldTitle: t('Στοιχεία απάντησης'), fieldType: 'TEXT' },
    { fieldName: 'sentDateText', fieldTitle: t('Ημερομηνία αποστολής'), fieldType: 'TEXT' },
    { fieldName: 'failedDateText', fieldTitle: t('Ημερομηνία αποτυχίας'), fieldType: 'TEXT' },
    { fieldName: 'failedReason', fieldTitle: t('Αιτία αποτυχίας'), fieldType: 'TEXT' },
  ];
};

/** Εξαγωγή παραληπτών — το where περιλαμβάνει ενημέρωση και τρέχον φίλτρο */
export async function handleExport(client, where: string, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetNotificationRecipients, {
      onCompleted: transformData,
      fetchPolicy: 'network-only',
    });

    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

    function transformData(data) {
      const recs = (data.getNotificationRecipients?.data ?? []).map((v) => ({
        ...v,
        cpName: v.collectionpoint?.name ?? '',
        addressLine1: v.collectionpoint?.addressLine1 ?? '',
        addressLine2: v.collectionpoint?.addressLine2 ?? '',
        addressArea: v.collectionpoint?.addressArea ?? '',
        addressCity: v.collectionpoint?.addressCity ?? '',
        addressNomos: v.collectionpoint?.addressNomos ?? '',
        statusLabel: notificationRecipientStatusLabel(v.statusId),
        responseLabel: notificationResponseValueLabel(v.responseValue),
        respondedDateText: v.respondedDate ? formatDateTime(v.respondedDate) : '',
        responsePayloadText: formatResponsePayload(v.responsePayload) ?? '',
        sentDateText: v.sentDate ? formatDateTime(v.sentDate) : '',
        failedDateText: v.failedDate ? formatDateTime(v.failedDate) : '',
      }));

      setResult([
        get,
        {
          loading,
          data: {
            getNotificationRecipients: {
              data: recs,
              recordCount: data?.getNotificationRecipients?.recordCount,
            },
          },
        },
      ]);
    }

    return result;
  }

  // Ίδιο where με το grid (ενημέρωση + φίλτρα)
  const filterVariables = {
    where: where ?? JSON.stringify({}),
  };

  await exportXlsModal({
    apolloClient: client,
    exportFileName: t('Εξαγωγή Παραληπτών Ενημέρωσης'),
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
